(() => {
  const initialize = () => document.querySelectorAll('[data-nf-orkie-placement]').forEach(root => {
    if (root.dataset.nfFallbackMounted) return;
    const fallback = root.querySelector('[data-nf-recommendation-fallback]');
    const engine = root.querySelector('[data-nf-orkie-engine]');
    if (!fallback || !engine) return;
    root.dataset.nfFallbackMounted = 'true';
    const update = () => {
      const result = engine.querySelector('[data-orkie-recommendation]');
      fallback.hidden = Boolean(result && !result.hidden && result.querySelector('.orkie-rec__item'));
    };
    update();
    new MutationObserver(update).observe(engine, {childList:true, subtree:true, attributes:true, attributeFilter:['hidden']});
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
